var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: {
        width: _vm.size + "px",
        height: _vm.size + "px",
        backgroundColor: _vm.userColor
      },
      attrs: { id: "avatar" }
    },
    [
      _c(
        "div",
        {
          staticClass: "initials",
          style: { "line-height": _vm.size + "px", "font-size": _vm.fontSize }
        },
        [_vm._v(_vm._s(_vm.initials))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5811d9ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5811d9ee","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Avatar.vue
// module id = 452
// module chunks = 4